export const GTM_CLICK_ON_COUPON_CODE = (context: string) => ({
  event: 'interaction_click on copy coupon code',
  e_category: 'navigation',
  e_action: 'Click on copy coupon code',
  amp_event_name: 'Click on copy coupon code',
  event_trigger: context,
  interaction_hit: 'False',
});
